import React, { useState } from 'react';
import Select, { components, createFilter } from 'react-select';
import PropTypes from 'prop-types';
const menuList = (props) => {
     return (
          <components.MenuList {...props} className={`${!Array.isArray(props.children) ? 'no-options' : ''}`}>
               {props.children}
          </components.MenuList>
     );
};

const SelectField = (props) => {
     const handleChange = (value) => {
          const { onChange, name, hasChange , isCustomReport, lvl2GroupIndex, lvl1GroupIndex} = props;
          if(isCustomReport){
               onChange({
                    lvl1GroupIndex,
                    lvl2GroupIndex,
                    propName: 'value',
                    propValue: value
               })
          }
          else {
               onChange(name, value);

          }
          if (hasChange) {
               hasChange();
          }
     };

     const handleBlur = () => {
          const { onBlur, name } = props;
          if(onBlur){
               onBlur(name, true);
          }
     };

     const {
          id,
          name,
          label,
          placeholder,
          options,
          value,
          isMulti,
          isDisabled,
          touched,
          error,
          isClearable,
          backspaceRemovesValue,
          noOptionsMessage,
          setErrors,
          className,
     } = props;

     const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

     return (
          <div className={`input-field-wrapper select-field-custom ${className}`}>
               {label && (
                    <>
                         <label className="input-label" htmlFor={name} error={error}>
                              {label}
                         </label>
                    </>
               )}

               <Select classNamePrefix='react-select'
                    className={`text-dark ${className}`}
                    id={id}
                    placeholder={defaultPlaceholder}
                    options={options}
                    value={value}
                    onChange={(e) => {
                         handleChange(e);
                         if (error) {
                              setErrors({});
                         }
                    }}
                    onBlur={handleBlur}
                    touched={touched}
                    error={error}
                    isMulti={isMulti}
                    isDisabled={isDisabled}
                    isClearable={isClearable}
                    backspaceRemovesValue={backspaceRemovesValue}
                    components={{ ClearIndicator: null, MenuList: menuList }}
                    noOptionsMessage={noOptionsMessage}
                    isSearchable={defaultPlaceholder !== placeholder}
                    onMenuOpen={() => setDefaultPlaceholder('Type here to filter the list…')}
                    onMenuClose={() => setDefaultPlaceholder(placeholder)}
                    filterOption={createFilter({
                         matchFrom: 'any',
                         stringify: (option) => `${option.label}`,
                    })}
               />
               {touched && error ? <p style={{ color: '#e55353', fontSize: '80%' }}>{error}</p> : null}
          </div>
     );
};


SelectField.propTypes = {
     name: PropTypes.string,
     lvl2GroupIndex: PropTypes.number,
     onChange: PropTypes.func,
     lvl1GroupIndex: PropTypes.number,
     isCustomReport: PropTypes.bool,
     hasChange: PropTypes.bool,
     onBlur: PropTypes.func,
     id: PropTypes.string,
     label: PropTypes.string,
     placeholder: PropTypes.string,
     options: PropTypes.array,
     value: PropTypes.string,
     isMulti: PropTypes.bool,
     isDisabled: PropTypes.bool,
     touched: PropTypes.any,
     error: PropTypes.object,
     isClearable: PropTypes.bool,
     backspaceRemovesValue: PropTypes.any,
     noOptionsMessage: PropTypes.any,
     setErrors: PropTypes.func,
     className: PropTypes.string,
};

export default SelectField;
